import { Component, input } from '@angular/core';

@Component({
  selector: 'vx-loading-screen',
  standalone: true,
  template: `
    @if (visible()) {
      <div class="loader">
        <img src="assets/brand/vaultrix-logo.jpeg" alt="VaulTriX">
      </div>
    }
  `,
  styles: [`
    .loader {
      position: fixed;
      inset: 0;
      z-index: 1000;
      display: grid;
      place-content: center;
      gap: 14px;
      text-align: center;
      color: white;
      background: radial-gradient(circle at 50% 35%, rgba(109, 93, 252, 0.5), transparent 20rem), #080c1d;
      animation: fadeOut 300ms ease 700ms both;
    }
    img {
      width: 180px;
      height: 180px;
      margin: 0 auto;
      border-radius: 28px;
      object-fit: contain;
      background: white;
      box-shadow: 0 0 44px rgba(0, 163, 255, 0.28);
      animation: pulse 1.4s ease infinite;
    }
    p {
      margin: 0;
      color: rgba(255, 255, 255, 0.7);
    }
    @keyframes pulse {
      50% { transform: scale(1.06); }
    }
    @keyframes fadeOut {
      to { opacity: 0; visibility: hidden; }
    }
  `]
})
export class LoadingScreenComponent {
  visible = input(false);
}
